module.exports = __webpack_public_path__ + "img/bg.a57b3362.jpg";